import { Component, inject, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { ConfiuracoesCategoriasComponent } from './components/confiuracoes-categorias/confiuracoes-categorias.component';
import { DoacaoConfigComponent } from './components/doacao-config/doacao-config.component';
import { EmprestimoConfigComponent } from './components/emprestimo-config/emprestimo-config.component';
import { RecompensaConfigComponent } from './components/recompensa-config/recompensa-config.component';
import { CommonModule } from '@angular/common';
import { GestaoPaginaComponent } from './components/gestao-pagina/gestao-pagina.component';
import { PerguntasFrequentesComponent } from './components/perguntas-frequentes/perguntas-frequentes.component';
import { TestemunhosConfigComponent } from './components/testemunhos-config/testemunhos-config.component';
import { FormGroup, ReactiveFormsModule, Validators, FormBuilder } from '@angular/forms';
import { Select } from 'primeng/select';
import { Dialog } from 'primeng/dialog';
import { MessageService } from 'primeng/api';
import { GestaoPaginaService } from '@app/shared/components/api/services/gestao-pagina.service';
import { GestaoPaginaEnum } from '@app/shared/components/api/models/gestaoPagina.model';
import { EnumService } from '@app/shared/components/api/services/enum.service';
import { forkJoin } from 'rxjs';
import { AnexoFicheiroService } from '@app/shared/components/api/services/anexo-ficheiro.service';
import { DashboardService } from '@app/shared/components/api/services/dashboard.service';
import { DashboardConfiguracaoResumoDto } from '@app/shared/components/api/models/dashboard.model';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-configuracoes',
  imports: [
    BackButtonComponent,
    ConfiuracoesCategoriasComponent,
    DoacaoConfigComponent,
    EmprestimoConfigComponent,
    RecompensaConfigComponent,
    CommonModule,
    GestaoPaginaComponent,
    PerguntasFrequentesComponent,
    TestemunhosConfigComponent,
    ReactiveFormsModule,
    Select,
    Dialog,
    ButtonModule
  ],
  providers: [
    GestaoPaginaService,
    EnumService,
    AnexoFicheiroService,
    DashboardService
  ],
  templateUrl: './configuracoes.component.html',
  styleUrl: './configuracoes.component.scss',
  standalone: true
})
export class ConfiguracoesComponent implements OnInit {
  private readonly fb = inject(FormBuilder);
  private readonly gestaoPaginaService = inject(GestaoPaginaService);
  private readonly messageService = inject(MessageService);
  private readonly enumService = inject(EnumService);
  private readonly anexoFicheiroService = inject(AnexoFicheiroService);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly dashboardService = inject(DashboardService);

  // Estatísticas de Configurações
  configStats: DashboardConfiguracaoResumoDto | null = null;
  totalConfigGeral: number = 0;
  loadingStats: boolean = true;

  // variaveis gerais
  tabIndex: number = 1;
  displayDialog: boolean = false;
  form!: FormGroup;
  banner: any;
  paginaOptions: any[] = [];
  tipoDadoOptions: any[] = [];
  selectedFile: File | null = null;
  PreviewIMG: File | null = null;
  imgPreview?: string;

  ngOnInit(): void {
    this.getConfigStats();
    this.getMideaByEnum();
    this.loaddropdowns();
    this.form = this.fb.group({
      Id: [null],
      GestaoPaginaENUM: [{ value: null, disabled: false }, Validators.required],
      GestaoPaginaTipoDadoENUM: [{ value: null, disabled: false }, Validators.required],
      anexo: [null, Validators.required]
    });

  }

  getConfigStats(): void {
    this.loadingStats = true;
    this.dashboardService.getDashboardConfiguracoes().subscribe({
      next: (res) => {
        this.configStats = res?.data || null;
        if (this.configStats?.configuracoesPorTipoGeral) {
          this.totalConfigGeral = this.configStats.configuracoesPorTipoGeral.reduce(
            (acc, curr) => acc + (curr.total || 0),
            0
          );
        }
        this.loadingStats = false;
      },
      error: (err) => {
        console.error('Erro ao carregar métricas de configurações:', err);
        this.loadingStats = false;
      }
    });
  }

  loaddropdowns() {
    forkJoin({
      // Enums
      gestaoPagina: this.enumService.getAllGestaoPagina(),
      tipodadoGestaoPagina: this.enumService.getAllGestaoPaginaTipoDado(),
      // Listas
    }).subscribe((response) => {
      // Enums
      if (response.gestaoPagina?.data) {
        this.paginaOptions = Object.entries(response.gestaoPagina.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value as string,
          })
        );
      }
      if (response.tipodadoGestaoPagina?.data) {
        this.tipoDadoOptions = Object.entries(response.tipodadoGestaoPagina.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value as string,
          })
        );
      }
      // Listas

    });
  }

  getMideaByEnum() {
    this.gestaoPaginaService.list({ GestaoPaginaENUM: GestaoPaginaEnum.BannerPrincipal }).subscribe({
      next: (result) => {
        this.banner = result.data[0];
        this.getPhoto(this.banner?.anexoID);
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  getPhoto(id: any) {
    if (!id) return;
    this.anexoFicheiroService.getAnexo(id).subscribe({
      next: (fotoRes: any) => {
        const blob = fotoRes instanceof Blob ? fotoRes : new Blob([fotoRes]);
         this.imgPreview = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob)) as any;
      },
      error: (err) => console.error(err)
    });
  }

  toggleTabsConfig(tab: number): void {
    this.tabIndex = tab;
  }

  getIconByTipo(tipo: number): string {
    switch (tipo) {
      case 1:
        return 'pi-file';        // Texto
      case 3:
        return 'pi-image';
      case 4:
        return 'pi-video';       // Vídeo
      case 5:
        return 'pi-link';        // Link
      default:
        return 'pi-folder';
    }
  }

  listenTipoDadoChanges() {
    this.form.get('GestaoPaginaTipoDadoENUM')?.valueChanges.subscribe(tipo => {
      const valorControl = this.form.get('Valor');

      if (tipo === 1 || tipo === 2) {
        valorControl?.setValidators([Validators.required]);
      } else {
        valorControl?.clearValidators();
        valorControl?.setValue(null);
      }

      valorControl?.updateValueAndValidity({ emitEvent: false });
    });
  }

  openEditDialog(item: any) {
    this.displayDialog = true;

    this.form.get('GestaoPaginaENUM')?.disable();
    this.form.get('GestaoPaginaTipoDadoENUM')?.disable();

    this.form.patchValue({
      Id: item.id,
      GestaoPaginaENUM: item.gestaoPaginaENUM,
      GestaoPaginaTipoDadoENUM: item.gestaoPaginaTipoDadoENUM,
    });
  }

  closeDialog() {
    this.displayDialog = false;
    this.form.reset();
  }

  isInvalid(controlName: string): boolean {
    const control = this.form.get(controlName);
    return !!(control && control.invalid && control.touched);
  }

  /** --- Funções de Upload --- **/
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    const file = input.files[0];
    const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];

    if (!validTypes.includes(file.type) || file.size > 5 * 1024 * 1024) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Apenas imagens PNG, JPG ou JPEG até 5MB são permitidas.',
        life: 5000
      });
      input.value = '';
      return;
    }

    this.selectedFile = file;
    this.PreviewIMG = file;
    this.form.patchValue({ anexo: file });
  }

  removeFile(): void {
    this.selectedFile = null;
    this.form.patchValue({ anexo: null });
  }

  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const raw = this.form.getRawValue();

    const formData = new FormData();

    // Cria o objeto que será enviado como payload
    const payloadObj: any = {
      Id: raw.Id ?? 0,
      GestaoPaginaENUM: raw.GestaoPaginaENUM,
      GestaoPaginaTipoDadoENUM: raw.GestaoPaginaTipoDadoENUM,
      valor: ''
    };

    // Adiciona o payload como string JSON
    formData.append('payload', JSON.stringify(payloadObj));

    // Se tiver anexo
    if (this.selectedFile) {
      formData.append('anexo', this.selectedFile);
    }

    this.gestaoPaginaService.store(formData).subscribe({
      next: (res) => {
        if (res.retorno?.codigo === 200) {
          this.closeDialog();
          this.getMideaByEnum();

          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Conteúdo atualizado com sucesso.'
          });
        } else {
          this.messageService.add({
            severity: 'warn',
            summary: 'Aviso',
            detail: res.retorno?.mensagem || 'Falha ao atualizar.'
          });
        }
      },
      error: (err) => {
        console.error(err);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Falha na operação.'
        });
      }
    });
  }
}
